import type { User } from '../types/User'

export const mockUsers: User[] = [
  /**
   * 공용 사용자 (특수 사용자)
   *
   * 주의: 이 사용자는 거래 등록 시 "공용" 지출자 선택을 위한 특수 사용자입니다.
   * - ID: 'user_shared'는 예약된 ID이므로 절대 변경/삭제하지 마세요
   * - 항상 배열의 맨 앞에 위치해야 UI에서 첫 번째 옵션으로 표시됩니다
   */
  {
    id: 'user_shared',
    email: 'shared@ourwallet',
    name: '공용',
    role: 'member',
    isActive: true,
    joinedAt: '2024-01-01T00:00:00',
  },
  /**
   * Mock 로그인 사용자 (개발용)
   *
   * @fix BUG-009: 권한 관리 테스트를 위한 Mock 유저
   * @why useAuth()의 Mock 모드에서 email: 'mock@example.com'을 사용하므로
   *      동일한 email을 가진 User를 추가하여 useCurrentUser()가 정상 동작하도록 함
   */
  {
    id: 'user_mock_1',
    email: 'mock@example.com', // useAuth()의 Mock email과 동일
    name: 'Mock User',
    role: 'owner', // Mock 모드에서는 owner로 설정하여 권한 테스트
    isActive: true,
    joinedAt: '2024-01-01T00:00:00',
  },
  {
    id: 'user_001',
    email: 'hong@gmail.com',
    name: '홍길동',
    role: 'owner',
    isActive: true,
    joinedAt: '2024-01-01T00:00:00',
  },
  {
    id: 'user_002',
    email: 'kim@gmail.com',
    name: '김영희',
    role: 'member',
    isActive: true,
    joinedAt: '2024-01-15T10:00:00',
  },
  {
    id: 'user_003',
    email: 'park@gmail.com',
    name: '박철수',
    role: 'member',
    isActive: true,
    joinedAt: '2024-02-01T09:00:00',
  },
]

export const currentUser = mockUsers[0]
